import React, { useEffect, useState, useRef, useCallback } from "react";
import { gsap } from "gsap";
import { motion } from "framer-motion";
import Select from "../Select";

// Components
import Modal from "../Modal";
import GuideMe from "./ModalIAIllustrations/GuideMe";
import OnMyOwn from "./ModalIAIllustrations/OnMyOwn";

const ModalIAIntro = (props) => {
  const { openNextModal, goToIAConversation } = props;

  return (
    <Modal isVisible={true} medium closeModal={props.closeModal}>
      <div>
        <h2 className="c-modal-ia__title">BIENVENID@ A LA IA DE T3</h2>
        <p>
          Interactúa con la IA para saber más acerca de los usuarios que han
          realizado la prueba de competencias. Puedes hacerlo libremente o
          déjate guiar con nuestros asistentes para obtener agrupamientos por
          estilos de perfil, detectar fortalezas o debilidades frecuentes,
          relaciones entre competencias ... y mucho más.
        </p>
      </div>
      <div className="c-modal-ia-intro__list">
        <div className="c-modal-ia-intro__list-item" onClick={openNextModal}>
          <GuideMe width={280} />
          <p>Prefiero dejarme guiar</p>
        </div>
        <div className="c-modal-ia-intro__list-item" onClick={goToIAConversation}>
          <OnMyOwn width={280} />
          <p>Me atrevo solit@ con la IA</p>
        </div>
      </div>
    </Modal>
  );
};

export default ModalIAIntro;
